import { Spherical, Vector3 } from "three";

export const sphericalCoords = (
  cameraPosition: Vector3,
  targetPosition: Vector3,
) => {
  // Calculate the vector from the camera to the target
  const direction = new Vector3()
    .subVectors(cameraPosition, targetPosition); // direction vector pointing from target to camera

  // Convert the direction vector to spherical coordinates
  const spherical = new Spherical().setFromVector3(direction);

  let thetaRadians = spherical.theta;
  let phiRadians = spherical.phi;

  // Convert radians to degrees
  const azimuth = (thetaRadians * 180) / Math.PI;
  const polar = (phiRadians * 180) / Math.PI;

  return {
    azimuth,
    polar,
  };
};
